export enum VersionStatusEnum {
  WaitingForApproval = 'waitingForApproval',
  Approved = 'approved',
  Rejected = 'rejected'
}
